module.exports = __webpack_public_path__ + "static/media/Rowdies-Bold.3cd3cfa6.ttf";